import { Overlay } from "./Overlay";

type AboutOverlayProps = {
  onDismissed: () => void
}

export const AboutOverlay: React.FC<AboutOverlayProps> = ({onDismissed}: AboutOverlayProps) => {
  return (
    <Overlay suffix="About" dismissButtonText="Close" onDismissed={onDismissed}>
      <br/>

      <h4><strong>Cardle</strong> was created by Millhouse in May 2022 - hope you're liking it!</h4>
      <br/>
      <h4><strong>Cardle</strong> is of course hugely indebted to <a href="https://www.nytimes.com/games/wordle/index.html" target="_blank" rel="noreferrer">Wordle</a> -
      thanks for the inspiration and fun!</h4>
      <br/>

      <h4>If you've enjoyed playing, you're very welcome to <strong>buy me a coffee</strong> over at <a target="_blank" rel="noreferrer" href="https://ko-fi.com/millhouse">Ko-fi</a> - drop me any suggestions there too.</h4>
      <br/>
      <br/>

      <h5 style={{textAlign: "center"}}>Dedicated to the memory of <strong>Brett Ardern</strong> 1975-2022</h5>
      <br/>

    </Overlay>
  )
}